import React from 'react';
import './FaqPage.scss';
import Title from '../../shared/components/title/Title';
import useIsMobile from '../../shared/hooks/global/UseIsMobile';
import MobilePageHeader from '../../shared/components/common/mobile-menu/MobilePageHeader';
import { useTranslation } from 'react-i18next';
import { Accordion, AccordionTab } from 'primereact/accordion';

const FaqPage: React.FC = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const transitionOpt = {
    transition: {
      timeout: 120,
    },
  };

  return (
    <>
      <div className="page-content page-content--faq">
        <div className="page-box">
          {/* Telefon: tytuł w górnym pasku zamiast nagłówka strony. */}
          <MobilePageHeader title={<span>{t('faqFull')}</span>} />
          {!isMobile && <Title title={t('faqFull')} />}
          <div className="page-box__stats">
            <Accordion className="accordion">
              <AccordionTab className="accordion__row" header={t('whatIsChatBeat')} pt={transitionOpt}>
                <p dangerouslySetInnerHTML={{ __html: t('whatIsChatBeatDesc') }} />
              </AccordionTab>
              <AccordionTab pt={transitionOpt} className="accordion__row" header={t('modelTrack')}>
                <p dangerouslySetInnerHTML={{ __html: t('modelTrackDesc') }} />
              </AccordionTab>

              <AccordionTab
                pt={transitionOpt}
                className="accordion__row"
                header={t('relevantQuestions')}
              >
                <p dangerouslySetInnerHTML={{ __html: t('relevantQuestionsDesc') }} />
              </AccordionTab>
              <AccordionTab pt={transitionOpt} className="accordion__row" header={t('metricsTrack')}>
                <p dangerouslySetInnerHTML={{ __html: t('metricsTrackDesc') }} />
              </AccordionTab>

              <AccordionTab
                className="accordion__row"
                header={t('mostOutOfChatbeat')}
                pt={transitionOpt}
              >
                <p dangerouslySetInnerHTML={{ __html: t('mostOutOfChatbeatDesc') }} />
              </AccordionTab>
              <AccordionTab
                pt={transitionOpt}
                className="accordion__row"
                header={t('whatIsShareOfVoice')}
              >
                <p dangerouslySetInnerHTML={{ __html: t('whatIsShareOfVoiceDesc') }} />
              </AccordionTab>
              <AccordionTab pt={transitionOpt} className="accordion__row" header={t('rawAIResponses')}>
                <p dangerouslySetInnerHTML={{ __html: t('rawAIResponsesDesc') }} />
              </AccordionTab>
              <AccordionTab pt={transitionOpt} className="accordion__row" header={t('visibilityRating')}>
                <p dangerouslySetInnerHTML={{ __html: t('visibilityRatingDesc') }} />
              </AccordionTab>
              <AccordionTab
                pt={transitionOpt}
                className="accordion__row"
                header={t('estimateAveragePosition')}
              >
                <p dangerouslySetInnerHTML={{ __html: t('estimateAveragePositionDesc') }} />
              </AccordionTab>
              <AccordionTab pt={transitionOpt} className="accordion__row" header={t('canITrackMyBrand')}>
                <p dangerouslySetInnerHTML={{ __html: t('canITrackMyBrandDesc') }} />
              </AccordionTab>
              <AccordionTab pt={transitionOpt} className="accordion__row" header={t('positionDiffer')}>
                <p dangerouslySetInnerHTML={{ __html: t('positionDifferDesc') }} />
              </AccordionTab>
              <AccordionTab
                pt={transitionOpt}
                className="accordion__row"
                header={t('whatIsSearchVolume')}
              >
                <p dangerouslySetInnerHTML={{ __html: t('whatIsSearchVolumeDesc') }} />
              </AccordionTab>

              <AccordionTab pt={transitionOpt} className="accordion__row" header={t('keySource')}>
                <p dangerouslySetInnerHTML={{ __html: t('keySourceDesc') }} />
              </AccordionTab>

              <AccordionTab
                pt={transitionOpt}
                className="accordion__row"
                header={t('whatIsTheContextTab')}
              >
                <p dangerouslySetInnerHTML={{ __html: t('whatIsTheContextTabDesc') }} />
              </AccordionTab>
            </Accordion>
          </div>
        </div>
      </div>
    </>
  );
};

export default FaqPage;
